// @flow

import React, { Component } from 'react'

import './AdministratorTable.css'
import Paginate from '../Buttons/Paginate'
import { dateTime } from '../timeutils'
import './SearchTermTable.css'

type Props = {
  changeOffset: Function,
  data: Array,
  page: number,
  totalTerms: number
}

/**
  * Diplay for search term table
  * @class
  * @extends Component
*/
class SearchTermTable extends Component<Props> {
  /** render function */
  render () {
    const headers = <tr><th>Term</th><th>Searches</th><th>Web</th><th>Mobile</th><th>Last time Searched</th></tr>
    const terms = this.props.data.map((term) => {
      return (
        <tr key={term.term}><td>{term.term} </td><td>{term.totalSearchCount}</td><td>{term.totalSearchCountWeb}</td><td>{term.totalSearchCountMobile}</td><td>{dateTime(term.lastTimeSearched)}</td></tr>
      )
    }
    )
    return (
      <div>

        <div className='table-wrapper'>
          <div className='SearchTable'>
            <h4>Top Searched Terms</h4>
            <table>
              <thead>{headers}</thead>
              <tbody>
                {terms}
              </tbody>
            </table>
          </div>
        </div>
        <Paginate changePage={(i) => this.props.changeOffset(i)} page={this.props.page} length={this.props.totalTerms} />
      </div>
    )
  }
}

export default SearchTermTable
